import Vue from 'vue'

// axios
import axios from 'axios'

const baseURL = `${process.env.VUE_APP_API_BASE_URL}/api`

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  baseURL,
  // baseURL: 'https://api-printing-main-dux9sm.laravel.cloud/api/',
  // timeout: 1000,
  // headers: {'X-Custom-Header': 'foobar'}
})

Vue.prototype.$http = axiosIns

export default axiosIns
